<div class="overview-grid">
    <div class="overview-grid-columns">
        <div class="overview-grid-left">
            <ubs-overview-detail [facilityId]="facilityId"></ubs-overview-detail>
            <ubs-overview-roles [facilityId]="facilityId"></ubs-overview-roles>
        </div>
        <div class="overview-grid-right">
            <ubs-overview-contacts [facilityId]="facilityId"></ubs-overview-contacts>
        </div>
    </div>
</div>



